module.exports = __webpack_public_path__ + "static/media/airpods_light.c6c363d9.svg";